export default "__VITE_ASSET__449257aa__"